import CustomTable from "../common/CustomTable";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { inventoryEntryPartIdState, modalTitle } from "../../utils/atoms/atoms";
import React from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAttdMonthById } from "../../api/attendance";
import { useEffect } from "react";
import { getInOutPartEntries } from "../../api/inventory";
import { inoutColumns } from "../../utils/table/inOutCols";

const PartInOutModalBody = () => {
  const queryClient = useQueryClient();
  const partEntryModalId = useRecoilValue(inventoryEntryPartIdState);
  const setModalTitle = useSetRecoilState(modalTitle);
  const {
    isLoading,
    data: partEntries,
    isSuccess,
  } = useQuery({
    queryKey: ["entries_part_id", partEntryModalId],
    queryFn: () => getInOutPartEntries(partEntryModalId),
  });

  const partEntryMutation = useMutation({
    mutationFn: async (partId: any) => {
      return getInOutPartEntries(partId);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["entries_part_id"], data);
      if (data.entries[0]?.emp_name) {
        setModalTitle(
          `${data.entries[0].part_name} - ${data.entries[0].drawing}`
        );
      } else {
        setModalTitle("Data not found");
      }
    },
  });

  useEffect(() => {
    if (partEntryModalId) {
      partEntryMutation.mutate(partEntryModalId);
    }
  }, [partEntryModalId]);

  return (
    <React.Fragment>
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable data={partEntries?.entries} columns={inoutColumns} />
      ) : (
        "Something went wrong"
      )}
    </React.Fragment>
  );
};

export default PartInOutModalBody;
